var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { trpc } from 'root/src/client/v2/trpc/trpc';
const STALE_TIME_MS = 1000 * 10;
// Fetches a single drop for the redesign drop page via tRPC (drops.getDrop reuses the legacy
// DROP_GET_EVENT handler, so the data shape matches the legacy page). Optional auth.
export const useDropEvent = (mnemonicId) => {
    const query = trpc.drops.getDrop.useQuery({ mnemonicId: mnemonicId !== null && mnemonicId !== void 0 ? mnemonicId : '' }, { enabled: Boolean(mnemonicId), staleTime: STALE_TIME_MS });
    return {
        drop: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: () => __awaiter(void 0, void 0, void 0, function* () {
            yield query.refetch();
        }),
    };
};
